export const GET_STOCKS = 'GET_STOCKS';
export const GET_STOCKS_ERROR = 'GET_STOCKS_ERROR';
export const GET_STOCKS_REQUEST = 'GET_STOCKS_REQUEST';
export const GET_STOCKS_SUCCESS = 'GET_STOCKS_SUCCESS';

export const SET_STOCKS = 'SET_STOCKS';
